import WritingAssignment from './component';

import {
  coreCatchUpWritingAssignment as _coreCatchUpWritingAssignment,
  spinWritingAssignment as _spinWritingAssignment,
} from './routes';

export const coreCatchUpWritingAssignment = _coreCatchUpWritingAssignment;
export const spinWritingAssignment = _spinWritingAssignment;

export default WritingAssignment;



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/StudentWritingAssignment/index.js